import {
  Alert,
  Box,
  Card,
  Chip,
  Grid,
  Icon,
  IconButton,
  Snackbar,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip
} from '@mui/material';
import { H6 } from 'app/components/Typography';
import { useState } from 'react';
import { Fragment } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteBulkStock from './DeleteBulkStock';
import FilterDiamondType from './FilterDiamondType';
import SearchCustomerStock from './SearchCustomerStock';
import { useNavigate } from 'react-router-dom';
import {
  genrateBulkInOutPdf,
  getBulkStockData
} from 'app/contexts/reducers/bulkStockMaster/bulkStockMasterSlice';
import UpdateBulkStockStatus from './UpdateBulkStockStatus';
import FilterStatus from './FilterStatus';

const CardHeader = styled(Box)(() => ({
  display: 'flex',
  paddingLeft: '24px',
  paddingRight: '24px',
  marginBottom: '12px',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

const Title = styled('span')(() => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize'
}));

const ProductTable = styled(Table)(() => ({
  minWidth: 1600,
  whiteSpace: 'nowrap',
  '& small': {
    width: 50,
    height: 15,
    borderRadius: 500,
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24)'
  },
  '& td': { borderBottom: 'none' },
  '& td:first-of-type': { paddingLeft: '16px !important' }
}));

const BulkStockTable = ({ apiCall, setApiCall }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { bulkStockData, isBulkStockMasterSuccess } = useSelector((state) => state.bulkStock);
  const [customerStockData, setCustomerStockData] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  const [deleteStockId, setDeleteStockId] = useState(null);
  const [updateStockId, setUpdateStockId] = useState(null);
  const [currentStatus, setCurrentStatus] = useState();
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [error, setError] = useState();
  useEffect(() => {
    dispatch(getBulkStockData());
  }, [dispatch, apiCall]);

  useEffect(() => {
    if (isBulkStockMasterSuccess) {
      const ordersWithStatusZero = bulkStockData.data.data.filter(
        (stock) => Number(stock.status) === 0
      );
      setCustomerStockData(ordersWithStatusZero);
    }
  }, [isBulkStockMasterSuccess, bulkStockData]);

  function handleDeleteClose() {
    setDeleteOpen(false);
  }
  function handleStatusUpdateClose() {
    setStatusOpen(false);
  }
  function handleSnakeBarClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessOpen(false);
    setErrorOpen(false);
  }
  function handleClickSuccess(message) {
    setErrorOpen(false);
    setSuccessMessage(message);
    setSuccessOpen(true);
  }
  function handleClickError() {
    setSuccessOpen(false);
    setErrorOpen(true);
  }
  return (
    <Fragment>
      <Card elevation={3} sx={{ pt: '20px', mb: 3 }}>
        <CardHeader>
          <Grid container justifyContent='space-between'>
            <Grid item>
              <Title>Bulk Stock Master</Title>
            </Grid>
            <Grid item>
              <Grid container spacing={1}>
                <Grid item>
                  <SearchCustomerStock setCustomerStockData={setCustomerStockData} />
                </Grid>
                <Grid item>
                  <FilterStatus setCustomerStockData={setCustomerStockData} />
                </Grid>
                <Grid item>
                  <FilterDiamondType setCustomerStockData={setCustomerStockData} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardHeader>

        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <ProductTable>
            <TableHead sx={{ backgroundColor: 'rgb(34,41,67)' }}>
              <TableRow>
                <TableCell colSpan={2} sx={{ px: 1, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Index
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Cus Name
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Diam Type
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 1, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Total Pcs
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Total Ct
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 1, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Used Pcs
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 1, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Used Ct
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Broken Pcs
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Broken Ct
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Missing Pcs
                </TableCell>
                <TableCell colSpan={3} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Missing Ct
                </TableCell>
                <TableCell colSpan={4} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Remaining Pcs
                </TableCell>
                <TableCell colSpan={4} sx={{ px: 0, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Remaining Ct
                </TableCell>

                <TableCell colSpan={3} sx={{ px: 2, fontWeight: 'bold', color: '#FFFFFF' }}>
                  Status
                </TableCell>
                <TableCell
                  colSpan={5}
                  align='center'
                  sx={{ pr: 3, fontWeight: 'bold', color: '#FFFFFF' }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {customerStockData && customerStockData.length > 0 ? (
                customerStockData.map((stock, index) => (
                  <TableRow key={index} hover>
                    <TableCell colSpan={2} sx={{ px: 0, textTransform: 'capitalize' }}>
                      <H6 sx={{ px: 1 }}>{stock.id}</H6>
                    </TableCell>
                    <TableCell
                      colSpan={3}
                      sx={{
                        px: 0,
                        textTransform: 'capitalize',
                        textAlign: 'left',
                        fontWeight: 'bold'
                      }}
                    >
                      {stock.customer_name}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 0, textTransform: 'capitalize' }}>
                      <Chip
                        label={stock.diamond_type}
                        component='p'
                        variant='filled'
                        color={stock.diamond_type === 'REAL' ? 'primary' : 'secondary'}
                      />
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 2, textTransform: 'capitalize' }}>
                      {parseFloat(parseFloat(stock.total_pcs).toFixed(3))}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 1, textTransform: 'capitalize' }}>
                      {parseFloat(parseFloat(stock.total_stock).toFixed(3))}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 3, textTransform: 'capitalize' }}>
                      {stock.used_pcs === null ? 0 : stock.used_pcs}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 3, textTransform: 'capitalize' }}>
                      {stock.used_stock === null
                        ? 0
                        : parseFloat(parseFloat(stock.used_stock).toFixed(3))}
                    </TableCell>

                    <TableCell colSpan={3} sx={{ px: 3, textTransform: 'capitalize' }}>
                      {stock.broken_pcs === null
                        ? 0
                        : parseFloat(parseFloat(stock.broken_pcs).toFixed(3))}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 3, textTransform: 'capitalize' }}>
                      {stock.broken_stock === null
                        ? 0
                        : parseFloat(parseFloat(stock.broken_stock).toFixed(3))}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 3, textTransform: 'capitalize' }}>
                      {stock.missing_pcs === null
                        ? 0
                        : parseFloat(parseFloat(stock.missing_pcs).toFixed(3))}
                    </TableCell>
                    <TableCell colSpan={3} sx={{ px: 3, textTransform: 'capitalize' }}>
                      {stock.missing_stock === null
                        ? 0
                        : parseFloat(parseFloat(stock.missing_stock).toFixed(3))}
                    </TableCell>
                    <TableCell
                      colSpan={4}
                      sx={{ px: 3, textTransform: 'capitalize', textAlign: 'left' }}
                    >
                      {stock.remaining_pcs}
                    </TableCell>
                    <TableCell
                      colSpan={4}
                      sx={{ px: 3, textTransform: 'capitalize', textAlign: 'left' }}
                    >
                      {parseFloat(parseFloat(stock.remaining_stock).toFixed(3))}
                    </TableCell>

                    <TableCell
                      colSpan={3}
                      sx={{ px: 0, textTransform: 'capitalize', textAlign: 'left' }}
                    >
                      <Chip
                        label={stock.status === '0' ? 'Running' : 'Completed'}
                        component='p'
                        variant='filled'
                        color={stock.status === '0' ? 'primary' : 'success'}
                      />
                    </TableCell>

                    <TableCell sx={{ px: 0 }} colSpan={5}>
                      <Tooltip title='Delete'>
                        <IconButton
                          onClick={() => {
                            setDeleteStockId(stock.id);
                            setDeleteOpen(true);
                          }}
                        >
                          <Icon color='error'>delete</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title='Update-Stauts'>
                        <IconButton
                          onClick={() => {
                            setUpdateStockId(stock.id);
                            setStatusOpen(true);
                            setCurrentStatus(stock.status);
                          }}
                        >
                          <Icon color='primary'>edit</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title='print'>
                        <IconButton
                          onClick={() => {
                            dispatch(
                              genrateBulkInOutPdf({
                                bulkStockId: stock.id
                              })
                            );
                          }}
                        >
                          <Icon color='primary'>print</Icon>
                        </IconButton>
                      </Tooltip>
                      <Tooltip title='view'>
                        <IconButton
                          onClick={() => {
                            const queryParams = {
                              customerId: stock.customer_id,
                              diamondType: stock.diamond_type,
                              status: stock.status,
                              stockId: stock.id
                            };
                            const queryString = new URLSearchParams(queryParams).toString();
                            navigate(`/specificbulkstock?${queryString}`);
                          }}
                        >
                          <Icon color='primary'>keyboard_arrow_right</Icon>
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={44} sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </ProductTable>
        </Box>
      </Card>
      {/* Alert */}
      <Snackbar open={successOpen} autoHideDuration={3000} onClose={handleSnakeBarClose}>
        <Alert
          onClose={handleSnakeBarClose}
          severity='success'
          sx={{ width: '100%' }}
          variant='filled'
        >
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={errorOpen} autoHideDuration={3000} onClose={handleSnakeBarClose}>
        <Alert
          onClose={handleSnakeBarClose}
          severity='error'
          sx={{ width: '100%' }}
          variant='filled'
        >
          {error?.payload}
        </Alert>
      </Snackbar>
      {/* Delete-Stock */}
      <DeleteBulkStock
        open={deleteOpen}
        onClose={handleDeleteClose}
        deleteStockId={deleteStockId}
        setApiCall={setApiCall}
        handleClickSuccess={handleClickSuccess}
        handleClickError={handleClickError}
        setError={setError}
      />
      {/* Update-Stock-Status */}
      <UpdateBulkStockStatus
        open={statusOpen}
        onClose={handleStatusUpdateClose}
        updateStockId={updateStockId}
        setApiCall={setApiCall}
        handleClickSuccess={handleClickSuccess}
        handleClickError={handleClickError}
        currentStatus={currentStatus}
        setError={setError}
      />
    </Fragment>
  );
};

export default BulkStockTable;
